<template>
  <v-list>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>아이디(휴대폰 번호)</v-list-item-title>
        <v-text-field
          solo
          ref="refCell"
          type="text"
          label="아이디(휴대폰 번호)"
          autofocus
          :height="52"
          :rules="[cellRules.required, cellRules.counter, cellRules.check]"
          v-model="userData.cell"
        >
          <template v-slot:append>
            <v-btn x-small depressed rounded color="mainColorDark" @click="clickCheckId">
              찾기
            </v-btn>
          </template>
        </v-text-field>
      </v-list-item-content>
    </v-list-item>

    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
  </v-list>

</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import ConfirmDialog from "@/_zplabZPT/commonComp/dialog/ConfirmDialog.vue";
const rulesService = require("@/utils/rules.js");

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    userData: {
      type: [Object],
    },
  },
  data() {
    return {
      cellRules: rulesService.cellRules(),
      reqData: {
        endpoint: "checkIdPw",
        checkType: "id",
        loginId: "",
      },
    };
  },
  methods: {
    clickCheckId() {
      // 필수
      const $h = this.$helper;
      const DT = this.userData;
      const RF = this.$refs;

      let msg = `아이디(휴대폰번호)를 입력해주세요`;
      if (!$h.requiredCheck(DT.cell, RF.refCell, msg)) return;

      if (DT.cell.length < 10) return;

      this.reqData.queryMethod = "POST";
      this.reqData.loginId = DT.cell;

      const message = `입력하신 휴대폰 번호로 임시 비밀번호를 발송하시겠습니까?`;
      this.$refs.refConfirmDialog.open(message);
    },
    clickPopupConfirm() {
      this.reqData.checkType = "yes";
      this.reqData.queryMethod = "POST";
      this.reqData.loginId = this.userData.cell;
      this.sendData();
    },
    sendData() {
      const $h = this.$helper;
      this.saveDataPreLoginQuery(this.reqData).then((res) => {
        if (res === undefined) return;

        if (res.checkType === "yes") {
          if (res.returnCode === 'notOK') {
            $h.showTostMessage("", res.message, "error");
            return;
          }
          if (res.returnCode === 'OK') {
            const message = `임시 비밀번호를 문자로 발송했습니다.\n
            메시지가 도착하지 않으면, 휴대폰 번호를 다시 확인해 주세요.`;
            $h.showTostMessage("", message, "success");

            setTimeout(() => {
              window.location.href = "/";
            }, 1000 * 3);
          }
        }
      });
    },
    ...mapActions(["saveDataPreLoginQuery"]),
  },
};
</script>
<style lang="">
</style>
